import apiClient from './apiClient'

// Default theme applied when bootstrapping a brand-new page. Colors are hex WITHOUT '#';
// 'x' means "use each social platform's own brand color" for icons.
export const DEFAULT_THEME = {
    bgColor: 'ffffff',
    iconColor: 'x',
    buttonColor: 'ff1493',
    fontStyle: 'REGULAR',
    buttonStyle: 'FILLED_ROUND',
}

/** The caller's pages (each bundles themeId, theme, links, socials). */
export async function getMyPages() {
    const { data } = await apiClient.get('/pages')
    return data
}

/** Public bundled page for vibio.co/{username}: { videoSrc, theme, links, socials }. */
export async function getPublicPage(username) {
    const { data } = await apiClient.get(`/pages/${username}`)
    return data
}

export async function createPage(body = { videoSrc: '', themeId: null }) {
    const { data } = await apiClient.post('/pages', body)
    return data
}

export async function updatePage(pageId, body) {
    const { data } = await apiClient.put(`/pages/${pageId}`, body)
    return data
}

async function createThemeForPage(pageId, theme = DEFAULT_THEME) {
    const { data } = await apiClient.post(`/themes/${pageId}`, theme)
    return data
}

// Single-flight guard: React StrictMode double-invokes the studio's bootstrap effect, and two
// concurrent runs would each create a page (duplicate rows + a SQLITE_BUSY write collision).
// Sharing one in-flight promise collapses concurrent callers into a single create.
let primaryPagePromise = null

/**
 * The user's primary page, creating one (plus a default theme) if none exists yet. New accounts
 * have no page until this runs, and users created before pages existed self-heal on first load.
 */
export function ensurePrimaryPage() {
    if (!primaryPagePromise) {
        primaryPagePromise = resolvePrimaryPage().finally(() => { primaryPagePromise = null })
    }
    return primaryPagePromise
}

async function resolvePrimaryPage() {
    let pages = await getMyPages()
    if (pages.length === 0) {
        const page = await createPage()
        await createThemeForPage(page.pageId) // server links the theme to the page
        pages = await getMyPages() // re-fetch so the page carries its themeId + bundled theme
    }
    return pages[0]
}
